import { combineReducers } from 'redux';

import classes from 'Root/pages/educator/modules/classes';
import toDoLists from 'Root/pages/careerpaths/modules/todolists';
import toDos from 'Root/pages/careerpaths/modules/todos';
import users from 'Root/modules/users';
import notifications from 'Root/modules/notifications';

export default combineReducers({
  toDos,
  toDoLists,
  users,
  classes,
  notifications,
});
